import { gql } from 'apollo-boost';

export const SEND_MAIL_TO_LEGAL_TEAM = gql`
  query SendMailToLegalTeam($input: LegalSupport!) {
    sendMailToLegalTeam(input: $input)
  }
`;
